import { Box, StringHelpers, SystemText } from 'e4shared';
import React from 'react';
import { withRouter } from 'react-router-dom';
import posthog from 'posthog-js';
import { translateCourse } from 'helpers/translations';
import { useSelector } from 'react-redux';

export const CourseCard = ({ text, course }) => {
    const { user } = useSelector(state => state.user);

    const [lms, setLMS] = React.useState({});

    React.useEffect(() => {
        var temp = translateCourse(user.language_Code, { ...course });
        setLMS(temp);
    }, [course]);

    let className = 'success';
    let statusStub = 'OnTime';

    if (lms.extras4 === 'completed' || lms.extras4 === 'course_completed') {
        className = 'success';
        statusStub = 'completed';
    } else if (lms.extras4 === 'in_progress' || lms.extras4 === 'course_started') {
        className = 'warning';
        statusStub = 'inProgress';
    } else {
        className = 'grey';
        statusStub = 'notStarted';
    }

    const onClick = data => {
        const accelerate = data.extras2 === 'accelerate';
        if (accelerate) {
            posthog.capture('launched-learning', { course: data.extras2, course_status: data.extras4, course_id: data.id });
            window.location.href = data.extras1;
        } else {
            window.open(data.extras1);
        }
    };

    return (
        <Box className={`box-${className} course-box pointer`} onClick={() => onClick(lms)}>
            <div className="flex flex-center">
                <label className={`label label-${className}`}>{text.card.statuses[statusStub]}</label>
                <div className="flex-grow"></div>
                <img src={`/dist/img/${lms.extras2}-icon.png`} alt={`${lms.extras2} logo`} />
            </div>
            <button data-testid="btn-explore-course" className="btn btn-link" onClick={() => onClick(lms)}>
                {lms.name}
            </button>
            <div className="description">{lms.description || lms.summary}</div>
            {lms.extras6 > 0 && (
                <div className="pull-right time">
                    <i className="fa fa-clock mr5" />
                    {StringHelpers.displayMinutes(lms.extras6 / 60)}
                </div>
            )}
        </Box>
    );
};

export default withRouter(CourseCard);
